// marketplace/ComboHero.jsx
// Full-bleed hero image carousel.
// Auto-advances every 5s. Dot indicators included.
// Images are 2400×1350 (16:9). Replace HERO_IMAGES urls when ready.

import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const HERO_IMAGES = [
  {
    url: "https://storage.googleapis.com/fastmax-images/74512c0d-b3da-4f56-aa6f-c4596dbba690-1.png",
    alt: "Promoción Fast Max",
  },
  {
    url: "https://storage.googleapis.com/fastmax-images/a0b84f1c-a087-4724-8717-d5c1c2f29c4b-3.png",
    alt: "Ofertas especiales",
  },
  {
    url: "https://storage.googleapis.com/fastmax-images/9c1c255b-e46d-42df-bf96-c472b8520154-2.png",
    alt: "Descuentos exclusivos",
  },
  {
    url: "https://storage.googleapis.com/fastmax-images/1aa974e5-ff15-41d1-8e91-5a3f6af7cab2-4.png",
    alt: "Fast Max Marketplace",
  },
];

export function ComboHero() {
  const [active, setActive] = useState(0);
  const timerRef            = useRef(null);

  const startTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActive(i => (i + 1) % HERO_IMAGES.length);
    }, 5000);
  };

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current);
  }, []);

  const goTo = (idx) => {
    setActive(idx);
    startTimer(); // reset timer on manual navigation
  };

  const goPrev = () => goTo((active - 1 + HERO_IMAGES.length) % HERO_IMAGES.length);
  const goNext = () => goTo((active + 1) % HERO_IMAGES.length);

  return (
    <div className="mx-auto max-w-7xl px-3 pt-4">
      <div
        className="relative rounded-2xl overflow-hidden"
        style={{ aspectRatio: "16 / 9" }}
      >
        {/* Slides */}
        {HERO_IMAGES.map((img, i) => (
          <div
            key={i}
            className="absolute inset-0 transition-opacity duration-700"
            style={{ opacity: i === active ? 1 : 0, zIndex: i === active ? 1 : 0 }}
          >
            <img
              src={img.url}
              alt={img.alt}
              className="w-full h-full object-cover"
              loading={i === 0 ? "eager" : "lazy"}
            />
          </div>
        ))}

        {/* Dot indicators */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
          {HERO_IMAGES.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className="rounded-full transition-all duration-300"
              style={{
                width:      i === active ? 16 : 6,
                height:     6,
                background: i === active ? "white" : "rgba(255,255,255,0.4)",
              }}
            />
          ))}
        </div>

        {/* Arrow buttons */}
        <button
          onClick={goPrev}
          className="absolute left-2 top-1/2 -translate-y-1/2 z-10 size-7 rounded-full bg-black/20 hover:bg-black/40 flex items-center justify-center transition-colors"
        >
          <ChevronLeft className="size-4 text-white" />
        </button>
        <button
          onClick={goNext}
          className="absolute right-2 top-1/2 -translate-y-1/2 z-10 size-7 rounded-full bg-black/20 hover:bg-black/40 flex items-center justify-center transition-colors"
        >
          <ChevronRight className="size-4 text-white" />
        </button>
      </div>
    </div>
  );
}